/**
 * Create a promo-code type promotion: name, single condition with code, shared discount for selected products.
 * @param {Function} requestWithMeta - useHttp().requestWithMeta
 * @param {{ name: string, code: string, discount: number, productIds: Array<number|string> }} payload
 * @returns {Promise<{ ok: boolean, data?: any, status?: number }>}
 */
export async function createPromoCodePromotion(requestWithMeta, payload) {
  const { name, code, discount, productIds } = payload;

  const trimmedName = name?.trim() ?? '';
  const trimmedCode = code?.trim() ?? '';
  const numericDiscount = Number(discount);

  const rewards =
    Array.isArray(productIds) && Number.isFinite(numericDiscount) && numericDiscount > 0
      ? productIds
          .filter((id) => id !== null && id !== undefined)
          .map((id) => ({
            productId: id,
            discount: numericDiscount,
          }))
      : [];

  const body = {
    name: trimmedName,
    imageUrl: null,
    conditions: [
      {
        typeId: 3, // PROMO_CODE (backend PromotionConditionType.PROMO_CODE)
        metaData: {
          code: trimmedCode,
        },
      },
    ],
    rewards,
  };

  const res = await requestWithMeta('/operator/promotions', 'POST', body);
  return { ok: res?.ok ?? false, data: res?.data, status: res?.status };
}

